<template>
  <div class="discover-difference-content margin-general">
    <div class="discover-difference-title">
      <h2>{{ $t("company.discover-difference.title") }}</h2>
    </div>
    <div class="discover-difference-text">
      <p
        v-for="(text, index) in filteredTexts"
        :key="index"
        :class="{'body-4': !text.bold, 'body-4-bold': text.bold, 'sub-title': true}"
      >
        {{ $t(text.key) }}
      </p>
    </div>
  </div>
</template>

<script setup>
/* import '@/assets/scss/components/company/discover-difference.scss'; */
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';


const { t: $t, locale } = useI18n();

const texts = ref([
  { key: "company.discover-difference.text1", visibleIn: [], hiddenIn: [] },
  { key: "company.discover-difference.text2", visibleIn: [], hiddenIn: [] },
  { key: "company.discover-difference.text3", visibleIn: [], hiddenIn: [] },
  { key: "company.discover-difference.text4", bold: true, visibleIn: [], hiddenIn: ["es-mx"] },
]);

const filteredTexts = computed(() => {
  const currentLocale = locale.value;
  return texts.value.filter(text => {
    const visibleIn = text.visibleIn.length === 0 || text.visibleIn.includes(currentLocale);
    const hiddenIn = !text.hiddenIn.includes(currentLocale);
    return visibleIn && hiddenIn;
  });
});
</script>